/* lua.js generated code 0.3.0 */

// FIXME: xpackage.seeall
// module("rpc", xpackage.seeall)

require("hecore/utils")
// NOT USED
// require("hecore/zlib")
require("hecore/EventDispatcher")

rpc = {}

rpc.SendingPriority = table.const(table(
    [1, "kHigh", "high"],
    [1, "kNormal", "normal"],
    [1, "kLow", "low"]
))
rpc.ChannelEvent = table.const(table(
    [1, "kAvailable", "available"],
    [1, "kServerError", "serverError"],
    [1, "kIOError", "ioError"],
    [1, "kTimeout", "timeout"],
    [1, "kComplete", "complete"]
))
rpc.InternalError = table.const(table(
    [1, "kDefaultError", -1],
    [1, "kNetworkError", -2],
    [1, "kTimeoutError", -3],
    [1, "kServerError", -4],
    [1, "kNoNetwork", -6],
    [1, "kServiceUnavailable", -7]
))
rpc.HttpStatus = table.const(table(
    [1, "HTTP_STATUS_NONE", 0],
    [1, "HTTP_OK", 200],
    [1, "HTTP_NULL_PTR", 206],
    [1, "HTTP_SERVICE_UNAVAILABLE", 503]
))
rpc.HEADER_COUNTER_FOR_OUTOFBAND = -999
rpc.GIP_SESSION_KEY_DELAY = 60 * 15
// var RpcRequest = xClass("RpcRequest")
// var RpcResponse = xClass("RpcResponse")
// RpcRequest.prototype.ctor = function (endpoint, data, handler, priority, outOfBand) {
//     var self = this
//     self.endpoint = endpoint
//     self.data = data
//     self.handler = handler
//     self.priority = priority
//     self.outOfBand = outOfBand
// }
// RpcResponse.prototype.ctor = function (endpoint, data, err, message, isEvent) {
//     var self = this
//     self.endpoint = endpoint
//     self.data = data
//     self.error = err
//     self.message = message
//     self.isEvent = isEvent
// }
// // HTTPChannel --------------------------------------------------
// // callback = function(retry) end               -- retry:boolean
// // function(callback) end
// networkErrorIntercaptor = null
// HTTPChannel = xClass("HTTPChannel", EventDispatcher)
// var sendCallback
// var isJustBlockRequest // use for add speed limit for he.HttpRequest
// HTTPChannel.prototype.ctor = function () {
//     var self = this
//     EventDispatcher.ctor(self)
//     self.closed = true
// }
// HTTPChannel.prototype.send = function (url, bytes, timeout, retryTimes) {
//     var self = this
//     self.closed = false
//     self.timeout = timeout
//     self.retryTimes = retryTimes
//     var request = he.HttpRequest.createPost(url)
//     if (isJustBlockRequest && !_G.skipHttpSpeedLitmit) {
//         isJustBlockRequest = false
//         request.setLowSpeedLimit(5 * 1000)
//         request.setLowSpeedTimeoutSeconds(15)
//     }
//     request.setConnectionTimeoutMs(timeout * 1000)
//     request.setTimeoutMs(30 * 1000)
//     request.addHeader("Content-Type:application/octet-stream")
//     request.setPostData(bytes, bytes.len())
//     var callbackHanler // 必须前置声明，否则在闭包本身内访问为nil
//     var channel = self
//     callbackHanler = function (response) {
//         channel.close()
//         if (response.httpCode !== 200 && type(networkErrorIntercaptor) === "function") {
//             networkErrorIntercaptor(function (retry) {
//                 if (retry) {
//                     channel.send(url, bytes, timeout, retryTimes)
//                 } else {
//                     sendCallback(response, channel)
//                 }
//             })
//         } else {
//             sendCallback(response, channel)
//         }
//     }
//     if (PrepackageUtil.isPreNoNetWork()) {
//         var fake_response = table([1, "httpCode", HttpStatus.HTTP_STATUS_NONE])
//         channel.close()
//         sendCallback(fake_response, channel)
//     } else {
//         he.HttpClient.getInstance().sendRequest(callbackHanler, request)
//     }
// }
// HTTPChannel.prototype.close = function () {
//     var self = this
//     self.closed = true
// }
// HTTPChannel.prototype.dispose = function () { }
// sendCallback = function (response, channel) {
//     if (response.httpCode === HttpStatus.HTTP_OK) {
//         channel.dispatchEvent(Event.new(ChannelEvent.kComplete, response, channel))
//     } else {
//         channel.dispatchEvent(Event.new(ChannelEvent.kIOError, response.httpCode, channel))
//     }
// }
// var ChannelRegistry = xClass("ChannelRegistry", EventDispatcher)
// ChannelRegistry.prototype.ctor = function (channelClass, maxChannel) {
//     var self = this
//     EventDispatcher.ctor(self)
//     self.channelClass = channelClass
//     self.maxChannel = type(maxChannel) === "number" && Math.max(1, maxChannel) || 1
//     self.enabledPool = table()
//     self.busyingPool = table()
// }
// ChannelRegistry.prototype.apply = function () {
//     var self = this
//     var channel
//     if ($len(self.enabledPool) > 0) {
//         channel = table.remove(self.enabledPool)
//     } else if ($len(self.busyingPool) < self.maxChannel) {
//         channel = self.channelClass.new()
//     }
//     if (channel) {
//         table.insert(self.busyingPool, channel)
//     }
//     return channel
// }
// ChannelRegistry.prototype.release = function (channel) {
//     var self = this
//     var index = table.indexOf(self.busyingPool, channel)
//     if (index) {
//         if ((!channel.closed)) {
//             channel.close()
//         }
//         table.remove(self.busyingPool, index)
//         table.insert(self.enabledPool, channel)
//         self.dispatchEvent(Event.new(ChannelEvent.kAvailable, null, self))
//     }
// }
// ChannelRegistry.prototype.dispose = function () {
//     var self = this
//     for (var i = 1, channel = self.enabledPool[1]; channel; i++, channel = self.enabledPool[i]) {
//         channel.dispose()
//     }
//     for (var i = 1, channel = self.busyingPool[1]; channel; i++, channel = self.busyingPool[i]) {
//         channel.dispose()
//     }
//     self.channelClass = null
//     self.enabledPool = null
//     self.busyingPool = null
// }
// // RpcProcessor ----------------------------------------------
// var RpcProcessor = xClass("RpcProcessor")
// var checkAuthorizable
// var getQueueEffectiveLength
// var extractAllStack
// var getAllStackLength
// var onChannelCallback
// var startCommunication
// var doProcess
// RpcProcessor.prototype.ctor = function (url, timeout, retryTimes, channelClass, maxChannel, sessionKeySource, skDelay) {
//     var self = this
//     self.url = url
//     self.timeout = timeout
//     self.retryTimes = retryTimes
//     self.sessionKeySource = sessionKeySource
//     self.skDelay = skDelay
//     self.queue = table()
//     self.holders = table()
//     self.stackRegistry = table()
//     self.outOfBandQueue = table()
//     self.convertorRegistry = table()
//     self.handlerRegistry = table()
//     self.channelRegistry = ChannelRegistry.new(channelClass, maxChannel)
//     self.channelRegistry.addEventListener(ChannelEvent.kAvailable, function (event) {
//         var processor = event.context
//         processor.process(false, event)
//     }, self)
// }
// RpcProcessor.prototype.process = function (immediately, event) {
//     var self = this
//     if ($len(self.outOfBandQueue) > 0 || checkAuthorizable(self, immediately)) {
//         var timediff = self.timediff || 0
//         if (self.sessionKey && self.timestamp && self.timestamp - timediff > os.time() + self.skDelay) {
//             doProcess(event, self)
//         } else if (!self.sessionRefreshing) {
//             var processor = self
//             var callback = function (sessionKey, timestamp) {
//                 processor.sessionRefreshing = null
//                 processor.sessionKey = sessionKey
//                 processor.timestamp = timestamp
//                 processor.convertorRegistry.assembleConvertor.updata(sessionKey)
//                 doProcess(event, processor)
//             }
//             self.sessionRefreshing = true
//             self.sessionKeySource(callback, self.sessionKey)
//         }
//     }
// }
// RpcProcessor.prototype.dispose = function () {
//     var self = this
//     self.channelRegistry.removeEventListener(ChannelEvent.kAvailable, doProcess)
//     self.channelRegistry.dispose()
//     self.queue = null
//     self.holders = null
//     self.stackRegistry = null
//     self.channelRegistry = null
//     self.convertorRegistry = null
//     self.handlerRegistry = null
// }
// checkAuthorizable = function (processor, immediately) {
//     var length = immediately && $len(processor.queue) || getQueueEffectiveLength(processor.queue)
//     processor.authorizedToSend = length > 0 || getAllStackLength(processor.stackRegistry) > 0
//     return processor.authorizedToSend
// }
// getQueueEffectiveLength = function (queue) {
//     var length = 0
//     for (var i = 1, request = queue[1]; request; i++, request = queue[i]) {
//         if (SendingPriority.kLow !== request.priority) {
//             length = length + 1
//         }
//     }
//     return length
// }
// extractAllStack = function (stackRegistry) {
//     var requests = table()
//     for (var k in stackRegistry) {
//         var stack = stackRegistry[k]
//         var request = stack.extract()
//         if (request) {
//             table.insert(requests, request)
//         }
//     }
//     return requests
// }
// getAllStackLength = function (stackRegistry) {
//     var size = 0
//     for (var k in stackRegistry) {
//         var stack = stackRegistry[k]
//         if (stack.request) {
//             size = size + 1
//         }
//     }
//     return size
// }
// doProcess = function (event, processor) {
//     if ((!event) || ChannelEvent.kAvailable === event.name) {
//         processor = processor || event.context
//         var channelRegistry = processor.channelRegistry
//         if ((!processor.queueSending) && processor.authorizedToSend) {
//             var channel = channelRegistry.apply()
//             if (channel) {
//                 var requests = table.union(processor.queue, extractAllStack(processor.stackRegistry))
//                 var endpoints = table()
//                 for (var i = 1, v = requests[1]; v; i++, v = requests[i]) {
//                     table.insert(endpoints, v.endpoint)
//                 }
//                 var sessionString = " uid: " + processor.uid + " sk:" + processor.sessionKey
//                 he_log_info(" [RPC] startCommunication: " + table.concat(endpoints, ",") + sessionString)
//                 table.removeAll(processor.queue)
//                 processor.queueSending = true
//                 processor.authorizedToSend = false
//                 startCommunication(processor, channel, requests)
//             }
//         }
//         var outOfBandQueue = processor.outOfBandQueue
//         if ($len(outOfBandQueue) > 0) {
//             var channel = channelRegistry.apply()
//             if (channel) {
//                 var requests = table()
//                 for (var i = 1, request = outOfBandQueue[1]; request; i++, request = outOfBandQueue[i]) {
//                     table.insert(requests, request)
//                 }
//                 table.removeAll(outOfBandQueue)
//                 startCommunication(processor, channel, requests, true)
//             }
//         }
//     }
// }
// startCommunication = function (processor, channel, requests, outOfBand) {
//     var convertorRegistry = processor.convertorRegistry
//     var assembleConvertor = convertorRegistry.assembleConvertor
//     if (convertorRegistry.packageConvertors) {
//         for (var i = 1, convertor = convertorRegistry.packageConvertors[1]; convertor; i++, convertor = convertorRegistry.packageConvertors[i]) {
//             requests = convertor.convertD(requests)
//         }
//     }
//     if (assembleConvertor) {
//         var bytes = assembleConvertor.convertD(requests)
//         if (convertorRegistry.binaryConvertors) {
//             for (var i = 1, convertor = convertorRegistry.binaryConvertors[1]; convertor; i++, convertor = convertorRegistry.binaryConvertors[i]) {
//                 bytes = convertor.convertD(bytes)
//             }
//         }
//         var url = processor.url + (string.find(processor.url, "?") && "&uid=" || "?uid=") + processor.uid + "&_t=" + os.time() + "&_v=" + bundleVersion
//         var holder = table.const(table(
//             [1, "url", url],
//             [1, "bytes", bytes],
//             [1, "requests", requests],
//             [1, "outOfBand", outOfBand && true || false]
//         ))
//         processor.holders[channel] = holder
//         channel.addEventListener(ChannelEvent.kComplete, onChannelCallback, processor)
//         channel.addEventListener(ChannelEvent.kIOError, onChannelCallback, processor)
//         channel.addEventListener(ChannelEvent.kServerError, onChannelCallback, processor)
//         channel.send(url, bytes, processor.timeout, processor.retryTimes)
//     } else {
//         he_log_error("Error : missing protocol assemble convertor for RpcTransponder")
//     }
// }
// var ignoreErrorType = table([1, 203, true], [1, 206, true])
// onChannelCallback = function (event) {
//     var channel = event.target
//     var processor = event.context
//     var holder = processor.holders[channel]
//     processor.holders[channel] = null
//     channel.removeEventListener(ChannelEvent.kComplete, onChannelCallback)
//     channel.removeEventListener(ChannelEvent.kIOError, onChannelCallback)
//     channel.removeEventListener(ChannelEvent.kServerError, onChannelCallback)
//     if (!holder.outOfBand) {
//         processor.queueSending = false
//     }
//     processor.channelRegistry.release(channel)
//     var handlerRegistry = processor.handlerRegistry
//     var convertorRegistry = processor.convertorRegistry
//     var responses, err, ts
//     if (ChannelEvent.kComplete === event.name) {
//         var http_response = event.data
//         var bytes = http_response.body
//         var headers = http_response.headers
//         if (!headers || !table.includes(headers, "Content-Type: application/octet-stream")) {
//             bytes = null
//         }
//         var binaryConvertors = convertorRegistry.binaryConvertors
//         if (binaryConvertors) {
//             var $var85 = $len(binaryConvertors)
//             for (var i = $var85; i >= 1; i += -1) {
//                 if (!bytes) {
//                     break
//                 }
//                 bytes = binaryConvertors[i].convertU(bytes)
//             }
//         }
//         if (bytes) {
//             ;[responses, err, ts] = convertorRegistry.assembleConvertor.convertU(bytes)
//             if (type(ts) === "number") {
//                 var diff = os.difftime(ts, os.time())
//                 if (!processor.timediff || Math.abs(processor.timediff - diff) > 300) {
//                     processor.timediff = diff
//                     _G.__g_utcDiffSeconds = processor.timediff
//                 }
//             }
//         } else {
//             err = InternalError.kNetworkError
//         }
//     } else if (ChannelEvent.kTimeout === event.name) {
//         err = InternalError.kTimeoutError
//     } else if (ChannelEvent.kIOError === event.name) {
//         var httpStatusCode = event.data
//         if (httpStatusCode === HttpStatus.HTTP_STATUS_NONE) {
//             err = InternalError.kNetworkError
//         } else if (httpStatusCode === HttpStatus.HTTP_SERVICE_UNAVAILABLE) {
//             err = InternalError.kServiceUnavailable
//         } else {
//             err = InternalError.kNetworkError
//         }
//     } else if (ChannelEvent.kServerError === event.name) {
//         err = InternalError.kServerError
//     } else {
//         err = InternalError.kDefaultError
//     }
//     if (err) { // global error
//         err = tonumber(err)
//         var errorHandlers = handlerRegistry[tostring(err)] || handlerRegistry[tostring(InternalError.kDefaultError)]
//         if (errorHandlers) {
//             var endpoints = table()
//             for (var i = 1, r = holder.requests[1]; r; i++, r = holder.requests[i]) {
//                 table.insert(endpoints, r.endpoint)
//             }
//             for (var i = 1, handler = errorHandlers[1]; handler; i++, handler = errorHandlers[i]) {
//                 // 全局错误传播可以阻断
//                 if (handler.handleError(endpoints, err, holder.requests)) {
//                     break
//                 }
//             }
//         } else if (err > 0 && !ignoreErrorType[err]) {
//             he_log_error("missing handler for global error '" + err + "'")
//         }
//         for (var i = 1, request = holder.requests[1]; request; i++, request = holder.requests[i]) {
//             var handler = request.handler
//             if (handler) {
//                 var handlerType = type(handler)
//                 if (handlerType === "function") {
//                     stopPropagate = handler(request.endpoint, null, err)
//                 } else if (handlerType === "table") {
//                     var ecodeHandler = handler[err]
//                     var errorHandler = handler.error
//                     if (ecodeHandler) {
//                         stopPropagate = ecodeHandler(request.endpoint, err)
//                     } else if (errorHandler) {
//                         stopPropagate = errorHandler(request.endpoint, err)
//                     }
//                 }
//             }
//         }
//     } else {
//         var packageConvertors = convertorRegistry.packageConvertors
//         if (packageConvertors) {
//             var $var103 = $len(packageConvertors)
//             for (var i = $var103; i >= 1; i += -1) {
//                 responses = packageConvertors[i].convertU(responses)
//             }
//         }
//         var requestIndex = 1
//         for (var i = 1, response = responses[1]; response; i++, response = responses[i]) {
//             //he_log_info("response: " .. response.endpoint)
//             err = response.error && tonumber(response.error)
//             var request = holder.requests[requestIndex]
//             var stopPropagate = false
//             if (err && !ignoreErrorType[err]) {
//                 he_log_error("RPC ERROR " + response.endpoint + "-" + tostring(err))
//             }
//             if (err === HttpStatus.HTTP_NULL_PTR || (err === 203 && response.endpoint !== "user" && response.endpoint !== "syncEnd")) {
//                 err = InternalError.kNoNetwork
//             }
//             if (request && request.endpoint === response.endpoint) {
//                 requestIndex = requestIndex + 1
//             } else {
//                 request = null
//             }
//             if (request && request.handler) {
//                 var handler = request.handler
//                 var handlerType = type(handler)
//                 if (handlerType === "function") {
//                     stopPropagate = handler(response.endpoint, response.data, err)
//                 } else if (handlerType === "table") {
//                     var completeHandler = handler.complete
//                     if (response.error) {
//                         var ecodeHandler = handler[err]
//                         var errorHandler = handler.error
//                         if (ecodeHandler) {
//                             stopPropagate = ecodeHandler(response.endpoint, err)
//                         } else if (errorHandler) {
//                             stopPropagate = errorHandler(response.endpoint, err)
//                         }
//                     } else if (completeHandler) {
//                         stopPropagate = completeHandler(response.endpoint, response.data)
//                     }
//                 }
//             }
//             if (!stopPropagate) {
//                 if (err) {
//                     var errorHandlers = handlerRegistry[tostring(err)] || handlerRegistry[tostring(InternalError.kDefaultError)]
//                     if (errorHandlers) {
//                         for (var i = 1, handler = errorHandlers[1]; handler; i++, handler = errorHandlers[i]) {
//                             handler.handleError(table([0, response.endpoint]), err)
//                         }
//                     } else if (err > 0 && !ignoreErrorType[err]) {
//                         he_log_error("missing handler for endpoint error '" + err + "'")
//                     }
//                 } else {
//                     var responseHandlers = handlerRegistry[response.endpoint]
//                     if (responseHandlers) {
//                         for (var i = 1, handler = responseHandlers[1]; handler; i++, handler = responseHandlers[i]) {
//                             handler.handleResponse(response.endpoint, response.data)
//                         }
//                     }
//                 }
//             }
//         }
//     }
// }
// AbsRpcStack = xClass("AbsRpcStack")
// AbsRpcStack.prototype.ctor = function (endpoint, keepSequence) {
//     var self = this
//     self.endpoint = endpoint
//     self.keepSequence = null != keepSequence && keepSequence || true
// }
// AbsRpcStack.prototype.extract = function () {
//     var self = this
//     var req = request
//     self.request = null
//     return req
// }
// ConcatRpcStack = xClass("ConcatRpcStack", AbsRpcStack)
// ConcatRpcStack.prototype.ctor = function (endpoint, keepSequence, propName) {
//     var self = this
//     AbsRpcStack.ctor(self, endpoint, keepSequence)
//     self.propName = propName
// }
// ConcatRpcStack.prototype.push = function (request) {
//     var self = this
//     var paramArray = request.data[self.propName]
//     if (type(paramArray) !== "table") {
//         he_log_error("invalidate request pushed into concat stack for endpoint '" + self.endpoint + "', with property type '" + type(paramArray) + "'")
//     } else if (self.request) {
//         var baseArray = self.request.data[self.propName]
//         for (var i = 1, v = paramArray[1]; v; i++, v = paramArray[i]) {
//             table.insert(baseArray, v)
//         }
//     } else {
//         self.request = request
//     }
// }
// KeeplastRpcStack = xClass("KeeplastRpcStack", AbsRpcStack)
// KeeplastRpcStack.prototype.push = function (request) {
//     var self = this
//     self.request = request
// }
// KeepfirstRpcStack = xClass("KeepfirstRpcStack", AbsRpcStack)
// KeepfirstRpcStack.prototype.push = function (request) {
//     var self = this
//     if (!self.request) {
//         self.request = request
//     }
// }
// // RpcTransponder ----------------------------------------------------------
// RpcTransponder = xClass("RpcTransponder")
// var isQueueFull
// var doCallProcess
// RpcTransponder.prototype.ctor = function (config, sessionKeySource) {
//     var self = this
//     self.queueSize = config.queueSize || 5
//     self.flushInterval = config.flushInterval || 10
//     self.defaultPriority = config.defaultPriority || SendingPriority.kHigh
//     self.time = 0
//     self.blocked = false
//     self.processor = RpcProcessor.new(config.url, config.timeout || 30, config.retryTimes || 0, config.channelClass || HTTPChannel, config.maxChannel || 1, sessionKeySource, GIP_SESSION_KEY_DELAY)
//     function update(dt) {
//         self.update(dt)
//     }
//     cc.Director.getInstance().getScheduler().scheduleScriptFunc(update, 1, false)
// }
// RpcTransponder.prototype.invalidateSessionKey = function () {
//     var self = this
//     self.processor.sessionKey = null
// }
// RpcTransponder.prototype.changeUID = function (uid) {
//     var self = this
//     var processor = self.processor
//     if (uid && processor.uid && processor.uid !== uid) {
//         var discards = table()
//         for (var i = 1, request = processor.queue[1]; request; i++, request = processor.queue[i]) {
//             table.insert(discards, request.endpoint)
//         }
//         for (var i = 1, request = processor.outOfBandQueue[1]; request; i++, request = processor.outOfBandQueue[i]) {
//             table.insert(discards, request.endpoint)
//         }
//         for (var k in processor.stackRegistry) {
//             var stack = processor.stackRegistry[k]
//             var request = stack.extract()
//             if (request) {
//                 table.insert(discards, request.endpoint)
//             }
//         }
//         processor.keepSequenceRpcStack = null
//         table.removeAll(processor.queue)
//         table.removeAll(processor.outOfBandQueue)
//         he_log_info("discard all pending requests: " + table.concat(discards, ","))
//         var assembleConvertor = processor.convertorRegistry.assembleConvertor
//         if (assembleConvertor) {
//             assembleConvertor.uk = null
//             assembleConvertor.counter = 0
//         }
//     }
//     processor.uid = uid
//     if (!self.blocked) {
//         self.flush()
//     }
// }
// RpcTransponder.prototype.dumpAndClean = function () {
//     var self = this
//     var processor = self.processor
//     var requests = table.union(processor.queue, extractAllStack(processor.stackRegistry))
//     for (var i = 1, request = processor.outOfBandQueue[1]; request; i++, request = processor.outOfBandQueue[i]) {
//         table.insert(requests, request)
//     }
//     table.removeAll(processor.queue)
//     table.removeAll(processor.outOfBandQueue)
//     processor.authorizedToSend = false
//     return requests
// }
// // handler
// //---- function(endpoint, data, err)
// //---- {complete=function(endpoint, data), error=function(endpoint, err)}
// //---- {complete=function(endpoint, data), 109=function(endpoint, err), 201=function(endpoint, err) ...}
// // handler return value
// //---- TRUE means stop propagate to registry handler
// //---- FALSE or NO VALUE means will propagate to registry handler
// RpcTransponder.prototype.call = function (endpoint, data, handler, priority, isLogin) {
//     var self = this
//     data = data || table()
//     priority = priority || self.defaultPriority
//     var processor = self.processor
//     var rpcStack = processor.stackRegistry[endpoint]
//     var rpcRequest = RpcRequest.new(endpoint, data, (!rpcStack) && handler || null, priority)
//     var keepSequenceRpcStack = processor.keepSequenceRpcStack
//     isJustBlockRequest = processor.queue && ($len(processor.queue) > 0)
//     if (rpcStack) {
//         if (keepSequenceRpcStack !== rpcStack && rpcStack.keepSequence) {
//             if (keepSequenceRpcStack) {
//                 table.insert(processor.queue, keepSequenceRpcStack.extract())
//                 if (isQueueFull(self)) {
//                     doCallProcess(self)
//                 }
//             }
//             processor.keepSequenceRpcStack = rpcStack
//         }
//         rpcStack.push(rpcRequest)
//     } else {
//         if (keepSequenceRpcStack) {
//             table.insert(processor.queue, keepSequenceRpcStack.extract())
//             processor.keepSequenceRpcStack = null
//         }
//         if (isLogin) {
//             var assembleConvertor = processor.convertorRegistry.assembleConvertor
//             if (assembleConvertor) {
//                 assembleConvertor.uk = null
//                 assembleConvertor.counter = 0
//             }
//             var tmpQueue = table()
//             for (var i = 1, request = processor.queue[1]; request; i++, request = processor.queue[i]) {
//                 table.insert(tmpQueue, request)
//             }
//             table.removeAll(processor.queue)
//             self.blocked = false
//             table.insert(processor.queue, rpcRequest)
//             doCallProcess(self)
//             for (var i = 1, request = tmpQueue[1]; request; i++, request = tmpQueue[i]) {
//                 table.insert(processor.queue, request)
//             }
//         } else {
//             table.insert(processor.queue, rpcRequest)
//         }
//         if (SendingPriority.kHigh === priority || isQueueFull(self)) {
//             doCallProcess(self)
//         }
//     }
// }
// RpcTransponder.prototype.callOutOfBand = function (endpoint, data, handler) {
//     var self = this
//     data = data || table()
//     var rpcRequest = RpcRequest.new(endpoint, data, handler, SendingPriority.kHigh, true)
//     table.insert(self.processor.outOfBandQueue, rpcRequest)
//     doCallProcess(self)
// }
// RpcTransponder.prototype.update = function (time) {
//     var self = this
//     self.time = self.time + time
//     if (self.time > self.flushInterval) {
//         self.time = 0
//         doCallProcess(self)
//     }
// }
// RpcTransponder.prototype.isBlocked = function () {
//     var self = this
//     return self.blocked
// }
// RpcTransponder.prototype.block = function () {
//     var self = this
//     self.blocked = true
// }
// RpcTransponder.prototype.unblock = function () {
//     var self = this
//     self.blocked = false
// }
// RpcTransponder.prototype.flush = function () {
//     var self = this
//     self.blocked = false
//     doCallProcess(self, true)
// }
// RpcTransponder.prototype.dispose = function () {
//     var self = this
//     processor.dispose()
//     self.class = null
// }
// RpcTransponder.prototype.registryConvertor = function (assembleConvertor, binaryConvertors, packageConvertors) {
//     var self = this
//     var convertorRegistry = self.processor.convertorRegistry
//     convertorRegistry.assembleConvertor = assembleConvertor
//     convertorRegistry.binaryConvertors = binaryConvertors && table.union(table(), binaryConvertors) || table()
//     convertorRegistry.packageConvertors = packageConvertors && table.union(table(), packageConvertors) || table()
// }
// RpcTransponder.prototype.registryRpcStack = function (stack) {
//     var self = this
//     self.processor.stackRegistry[stack.endpoint] = stack
// }
// RpcTransponder.prototype.unregistryRpcStack = function (stack) {
//     var self = this
//     var stackRegistry = self.processor.stackRegistry
//     if (stackRegistry[stack.endpoint] === stack) {
//         stackRegistry[stack.endpoint] = null
//     }
// }
// RpcTransponder.prototype.registryHandler = function (handler) {
//     var self = this
//     var handlerRegistry = self.processor.handlerRegistry
//     if (type(handler.endpoints) === "table") {
//         for (var endpoint in handler.endpoints) {
//             handlerRegistry[endpoint] = table.insertIfNotExist(handlerRegistry[endpoint], handler)
//         }
//     }
//     if (type(handler.errors) === "table") {
//         for (var err in handler.errors) {
//             err = tostring(err)
//             handlerRegistry[err] = table.insertIfNotExist(handlerRegistry[err], handler)
//         }
//     }
// }
// RpcTransponder.prototype.unregistryHandler = function (handler) {
//     var self = this
//     var handlerRegistry = self.processor.handlerRegistry
//     if (type(handler.endpoints) === "table") {
//         for (var endpoint in handler.endpoints) {
//             table.removeIfExist(handlerRegistry[endpoint], handler)
//         }
//     }
//     if (type(handler.errors) === "table") {
//         for (var err in handler.errors) {
//             table.removeIfExist(handlerRegistry[tostring(err)], handler)
//         }
//     }
// }
// isQueueFull = function (transponder) {
//     var queue = transponder.processor.queue
//     if ($len(queue) > transponder.queueSize) {
//         var size = 0
//         for (var i = 1, request = queue[1]; request; i++, request = queue[i]) {
//             if (SendingPriority.kLow !== request.priority) {
//                 size = size + 1
//                 if (size > transponder.queueSize) {
//                     return true
//                 }
//             }
//         }
//     }
//     return false
// }
// doCallProcess = function (transponder, immediately) {
//     var uid = transponder.processor.uid
//     if (!transponder.blocked && uid) {
//         transponder.time = 0
//         transponder.processor.process(immediately)
//     }
// }
// HeaderConvertor = xClass("HeaderConvertor")
// HeaderConvertor.prototype.convertD = function (bytes) {
//     var self = this
//     // WARN: maybe multi result
//     return headercvt.convertD(bytes)
// }
// HeaderConvertor.prototype.convertU = function (bytes) {
//     var self = this
//     // WARN: maybe multi result
//     return headercvt.convertU(bytes)
// }
// // CompressConvertor ----------------------------------------------------------
// CompressConvertor = xClass("CompressConvertor")
// CompressConvertor.prototype.convertD = function (bytes) {
//     var self = this
//     // WARN: maybe multi result
//     return compress(bytes)
// }
// CompressConvertor.prototype.convertU = function (bytes) {
//     var self = this
//     // WARN: maybe multi result
//     return uncompress(bytes)
// }
// // AssembleConvertor ----------------------------------------------------------
// AssembleConvertor = xClass("AssembleConvertor")
// var pickResponseMeta
// AssembleConvertor.prototype.ctor = function (amf3Enabled, version, metaVersion, appID, language, platformFinder, clientType, uk, counter, others) {
//     var self = this
//     self.amf3Enabled = amf3Enabled
//     self.version = version
//     self.metaVersion = metaVersion
//     self.appID = appID
//     self.language = language
//     self.platformFinder = platformFinder
//     self.clientType = clientType
//     self.uk = uk
//     self.counter = type(counter) === "number" && counter || 0
//     self.others = type(others) === "table" && others || table()
// }
// AssembleConvertor.prototype.updata = function (sessionKey) {
//     var self = this
//     self.sessionKey = sessionKey
// }
// AssembleConvertor.prototype.convertD = function (requests) {
//     var self = this
//     var header = table(
//         [1, "v", self.version],
//         [1, "mv", self.metaVersion],
//         [1, "ct", self.clientType],
//         [1, "aid", self.appID],
//         [1, "lang", self.language],
//         [1, "pf", self.platformFinder()],
//         [1, "notify", true],
//         [1, "sk", self.sessionKey],
//         [1, "uk", self.uk],
//         [1, "others", self.others]
//     )
//     if (!header.uk) {
//         self.counter = 0
//     }
//     var headerInfo = table()
//     for (var k in header) {
//         var v = header[k]
//         table.insert(headerInfo, k + "=" + tostring(v))
//     }
//     //he_log_info("communication request header: " .. table.concat(headerInfo, ","))
//     for (var i = 1, request = requests[1]; request; i++, request = requests[i]) {
//         if (request.outOfBand) {
//             header.st = HEADER_COUNTER_FOR_OUTOFBAND
//             break
//         }
//     }
//     if (!header.st) {
//         header.st = self.counter
//         self.counter = self.counter + 1
//     }
//     var data = table([0, header], [0, table()])
//     for (var i = 1, request = requests[1]; request; i++, request = requests[i]) {
//         request.data.method = request.endpoint
//         table.insert(data[2], request.data)
//     }
//     return self.amf3Enabled && amf3.encode(data) || data
// }
// AssembleConvertor.prototype.convertU = function (bytes) {
//     var self = this
//     var responseData = self.amf3Enabled && amf3.decode(bytes) || bytes
//     var responses = table()
//     var subHeader = responseData[1]
//     var events = responseData[3]
//     var code = tonumber(subHeader.errCode)
//     var ts = tonumber(subHeader.ts)
//     code = code && code > 0 && code || null
//     var headerInfo = table()
//     for (var k in subHeader) {
//         var v = subHeader[k]
//         table.insert(headerInfo, k + "=" + tostring(v))
//     }
//     //he_log_info("communication response header: " .. table.concat(headerInfo, ","))
//     if (!code) {
//         if (subHeader.uk) {
//             self.uk = subHeader.uk
//         }
//         if (subHeader.st) {
//             self.counter = Math.max(self.counter, tonumber(subHeader.st))
//         }
//     }
//     for (var i = 1, response = responseData[2][1]; response; i++, response = responseData[2][i]) {
//         table.insert(responses, pickResponseMeta(response, ts))
//     }
//     if (type(events) === "table") {
//         for (var i = 1, event = events[1]; event; i++, event = events[i]) {
//             table.insert(responses, pickResponseMeta(event, ts, true))
//         }
//     }
//     // FIXME: multi result
//     return [responses, code, ts]
// }
// pickResponseMeta = function (data, ts, isEvent) {
//     var endpoint = data.method
//     var code = tonumber(data.retCode)
//     var message = data.extraMsg
//     data.method = null
//     data.retCode = null
//     data.extraMsg = null
//     // WARN: maybe multi result
//     return RpcResponse.new(endpoint, data, code !== 200 && code || null, message, isEvent)
// }
// PackageConvertor = xClass("PackageConvertor")
// PackageConvertor.prototype.convertD = function (requests) {
//     var self = this
//     return requests
// }
// PackageConvertor.prototype.convertU = function (responses) {
//     var self = this
//     return responses
// }
module.exports = rpc